import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AnonymousRoute } from 'components/common/Route';
import SignOut from 'routes/SignOut';
import routes, { RoutesWithLayout } from './RoutesWithLayout';
import Root from './Root';
import signUpRoutes, { SignUpLayout } from './SignUp';
import SelectAccountType from './SignUp/SelectAccountType';
import DownloadTheApp from './DownloadTheApp';
import FirstAlertSignIn from './FirstAlert/FirstAlertSignIn';
import PageError from 'components/common/PageError';
import MaintenancePage from 'components/common/MaintenancePage';
import { MAINTENANCE_MODE } from 'config/flags';

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        path: '/*',
        element: (
          <AnonymousRoute>
            <RoutesWithLayout />
          </AnonymousRoute>
        ),
        children: routes,
      },
      {
        path: 'sign-out',
        element: (
          <AnonymousRoute>
            <SignOut />
          </AnonymousRoute>
        ),
      },
      {
        path: 'sign-up/*',
        element: (
          <AnonymousRoute>
            {MAINTENANCE_MODE ? <MaintenancePage /> : <SignUpLayout />}
          </AnonymousRoute>
        ),
        children: MAINTENANCE_MODE ? [] : signUpRoutes,
      },
      {
        path: 'get-started/*',
        element: (
          <AnonymousRoute>
            {MAINTENANCE_MODE ? <MaintenancePage /> : <SelectAccountType />}
          </AnonymousRoute>
        ),
      },
      {
        path: 'mobile/*',
        element: (
          <AnonymousRoute>
            <DownloadTheApp />
          </AnonymousRoute>
        ),
      },
      {
        path: 'firstalert/callback-signin',
        element: (
          <AnonymousRoute>
            <FirstAlertSignIn />
          </AnonymousRoute>
        ),
      },
      // Test route for PageError component coverage
      ...(process.env.NODE_ENV !== 'production'
        ? [
            {
              path: 'test-page-error',
              element: <PageError />,
            },
            {
              path: 'test-page-error-custom',
              element: (
                <PageError
                  header='Custom Test Error'
                  content='This is a test error for coverage'
                />
              ),
            },
            {
              path: 'test-page-error-reset',
              element: (
                <PageError
                  header='Error with Reset'
                  content='Testing reset callback'
                  resetError={() => {
                    // Reset callback for testing
                  }}
                />
              ),
            },
          ]
        : []),
    ],
  },
]);

export default router;
